import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { Action, NgxsModule, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';

import { HttpRequestAction } from './state/actions';
import { HttpRequestDataProvider } from './types';

@State({ name: 'coreHttp' })
export class CoreHttp {
  @Action(HttpRequestAction)
  public onHttpRequest(ctx: StateContext<any>, action: HttpRequestAction): Observable<any> {
    return action.request;
  }
}

@NgModule({
  imports: [HttpClientModule, NgxsModule.forFeature([CoreHttp])],
})
export class RtHttpModule {
  public static forRoot(
    httpRequestDataProvider: HttpRequestDataProvider,
  ): ModuleWithProviders<RtHttpModule> {
    return { ngModule: RtHttpModule, providers: [httpRequestDataProvider] };
  }
}
